import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";

/**
 * Whether the demo banner should offer the "ask my admin for access" CTA.
 *
 * Called per render rather than read once at module scope — sales workspace resources may not be ready at
 * import time.
 */
export const canRequestDemoAccess = (): boolean => !salesSettingsHelper.isAdmin();
